import React, { useRef } from "react";

const Contact = () => {
  const sectionsRef = useRef([]);

  return (
    <section
      className="animated-section"
      ref={(el) => (sectionsRef.current[0] = el)}
      style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", minHeight: "100vh", paddingTop: "40px" }}
    >
      <div className="section-inner">
        <div
          style={{
            maxWidth: "600px",
            margin: "0 auto",
            backgroundColor: "#f9f9f9",
            border: "2px solid #500000",
            borderRadius: "8px",
            padding: "24px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{
              color: "#500000",
              fontSize: "24px",
              textAlign: "center",
              marginBottom: "16px",
            }}
          >
            Contact Us
          </h2>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.8",
              textAlign: "justify",
              marginBottom: "20px",
            }}
          >
            For questions about the program or help with the application process,
            please contact our team. We're here to support your engagement with
            the Data Science community at Texas A&amp;M.
          </p>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <h3 style={{ margin: "8px 0", color: "#500000" }}>Drew Casey</h3>
            <p style={{ margin: "4px 0" }}>
              Assistant Director of Program Engagement
            </p>
            <p style={{ margin: "4px 0" }}>
              TAMIDS • Texas A&amp;M University
            </p>
            <p style={{ margin: "8px 0" }}>
              <a
                href="mailto:drew.casey@tamu.edu"
                style={{ color: "#500000", textDecoration: "underline" }}
              >
                drew.casey@tamu.edu
              </a>
            </p>
          </div>
          <div style={{ textAlign: "center", marginTop: "16px" }}>
            <a
              href="/"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "#fff",
                color: "#500000",
                border: "2px solid #500000",
                borderRadius: "4px",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              Back to Login
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;